{
  "page": {
    "title": "Vận hành bán hàng",
    "subtitle": "Phân tích GMV, sản xuất và dự báo"
  },
  "tabs": {
    "dashboard": "Tổng quan",
    "comparison": "So sánh sản phẩm",
    "forecast": "Dự báo"
  },
  "range": {
    "label": "Khoảng tháng",
    "trigger": "Chọn khoảng tháng",
    "from": "Từ",
    "to": "Đến",
    "apply": "Áp dụng",
    "cancel": "Hủy",
    "invalid": "\"Từ\" phải nhỏ hơn hoặc bằng \"Đến\"",
    "monthAria": "Chọn tháng"
  },
  "freshness": {
    "ready": "Dữ liệu tính đến {{when}}",
    "stale": "Dữ liệu có thể đã cũ — cập nhật lần cuối {{when}}",
    "bootstrapping": "Đang xây dựng phân tích lần đầu. Số liệu sẽ hiển thị trong giây lát.",
    "recomputing": "Đang tính lại phân tích — dữ liệu tính đến {{when}}",
    "unknown": "Không rõ độ mới của dữ liệu"
  },
  "cardState": {
    "loading": "Đang tải…",
    "bootstrapping": "Báo cáo này vẫn đang được chuẩn bị.",
    "empty": "Không có dữ liệu trong khoảng đã chọn.",
    "insufficient": "Không đủ dữ liệu để tính giá trị đáng tin cậy.",
    "error": "Không thể tải phần này.",
    "retry": "Thử lại"
  },
  "sectionNav": {
    "label": "Chuyển tới mục",
    "tiles": "Tổng quan",
    "weekly": "GMV theo tuần",
    "channel": "Cơ cấu kênh",
    "status": "Cơ cấu trạng thái",
    "pivot": "Bảng chéo trạng thái",
    "products": "Sản phẩm hàng đầu",
    "refund": "Tỷ lệ hoàn tiền",
    "variants": "Biến thể hàng đầu",
    "factories": "Nhà máy",
    "production": "Sản xuất",
    "regions": "Khu vực",
    "dataQuality": "Chất lượng dữ liệu"
  },
  "dashboard": {
    "title": "Bảng điều khiển vận hành",
    "statTiles": {
      "platformGmv": "GMV nền tảng",
      "orders": "Đơn hàng",
      "items": "Sản phẩm",
      "avgOrderValue": "Giá trị đơn trung bình",
      "gmvTooltipAria": "Giới thiệu về GMV nền tảng",
      "gmvFormulaTitle": "GMV nền tảng",
      "gmvFormulaBody": "Tổng giá trị các đơn đã thanh toán trên mọi kênh trong khoảng đã chọn.",
      "gmvDiffersNote": "Khác với GMV được phân bổ trong Báo cáo GMV."
    },
    "weeklyGmv": {
      "title": "GMV theo tuần",
      "subtitle": "{{current}} so với {{previous}}",
      "xAxisLabel": "Tuần ISO",
      "weekTick": "T{{week}}",
      "legendCurrent": "{{year}}",
      "legendPrevious": "{{year}}",
      "legendPartial": "Tuần hiện tại (chưa trọn)",
      "priorYearEmptyNote": "Không có dữ liệu năm {{year}} để so sánh."
    }
  },
  "channel": {
    "normal": "Thường",
    "sample": "Mẫu",
    "tiktok": "TikTok"
  },
  "status": {
    "Open": "Đang mở",
    "Paid": "Đã thanh toán",
    "Unpaid": "Chưa thanh toán",
    "Pending": "Chờ xử lý",
    "Processing": "Đang xử lý",
    "InProduction": "Đang sản xuất",
    "Shipped": "Đã gửi hàng",
    "Delivered": "Đã giao",
    "Completed": "Hoàn tất",
    "Cancelled": "Đã hủy",
    "Refunded": "Đã hoàn tiền",
    "PartiallyRefunded": "Hoàn tiền một phần",
    "OnHold": "Tạm giữ",
    "Failed": "Thất bại"
  },
  "channelMix": {
    "title": "GMV theo kênh",
    "sharePct": "{{pct}}%",
    "orders": "{{count}} đơn",
    "empty": "Không có dữ liệu kênh trong khoảng đã chọn.",
    "loadingAria": "Đang tải cơ cấu kênh",
    "figureAria": "Tỷ trọng GMV theo kênh"
  },
  "statusMix": {
    "orderTitle": "GMV theo trạng thái đơn",
    "paymentTitle": "GMV theo trạng thái thanh toán",
    "orders": "{{count}} đơn",
    "empty": "Không có dữ liệu trạng thái trong khoảng đã chọn.",
    "loadingAria": "Đang tải cơ cấu trạng thái",
    "orderFigureAria": "GMV theo trạng thái đơn",
    "paymentFigureAria": "GMV theo trạng thái thanh toán"
  },
  "statusPivot": {
    "title": "Trạng thái đơn × trạng thái thanh toán",
    "caption": "GMV theo trạng thái đơn và trạng thái thanh toán",
    "rowHeader": "Trạng thái đơn",
    "empty": "Không có dữ liệu bảng chéo trong khoảng đã chọn.",
    "loadingAria": "Đang tải bảng chéo trạng thái",
    "cellTitle": "{{order}} · {{payment}}: {{gmv}} ({{count}} đơn)"
  },
  "topProducts": {
    "title": "Sản phẩm hàng đầu theo doanh thu",
    "sortBy": "Sắp xếp theo {{column}}",
    "columns": {
      "product": "Sản phẩm",
      "revenue": "Doanh thu",
      "qty": "SL",
      "orders": "Đơn"
    }
  },
  "factories": {
    "title": "Nhà máy",
    "unmapped": "Chưa gán quốc gia",
    "expandRow": "Xem chi tiết của {{vendor}}",
    "collapseRow": "Ẩn chi tiết của {{vendor}}",
    "columns": {
      "vendor": "Nhà cung cấp",
      "country": "Quốc gia",
      "gmv": "GMV",
      "products": "Sản phẩm",
      "orders": "Đơn",
      "medianProduction": "Thời gian SX trung vị"
    },
    "drilldown": {
      "empty": "Không có sản phẩm nào của nhà cung cấp này trong khoảng đã chọn.",
      "insufficient": "Chưa đủ mẫu",
      "hours": "{{value}} giờ",
      "columns": {
        "product": "Sản phẩm",
        "orders": "Đơn",
        "qty": "SL",
        "medianProduction": "Thời gian SX trung vị"
      }
    }
  },
  "production": {
    "title": "Hiệu suất sản xuất",
    "colProduct": "Sản phẩm",
    "colOrders": "Đơn",
    "colApproval": "Duyệt trung vị",
    "colProduction": "Sản xuất trung vị",
    "colItemsPerOrder": "SP / đơn",
    "hours": "{{value}} giờ",
    "insufficient": "Chưa đủ mẫu ({{n}})",
    "insufficientTooltip": "Ít hơn 5 mẫu — đã ẩn giá trị trung vị."
  },
  "refund": {
    "title": "Tỷ lệ hoàn tiền / gửi lại",
    "colProduct": "Sản phẩm",
    "colMonth": "Tháng",
    "colRate": "Tỷ lệ",
    "colAmount": "Số tiền hoàn",
    "monthOverrideLabel": "Tháng",
    "monthAll": "Tất cả các tháng",
    "flaggedSr": "Vượt ngưỡng {{threshold}}"
  },
  "regions": {
    "title": "Khu vực giao hàng",
    "byCountry": "Theo quốc gia",
    "byState": "Theo bang",
    "legendGmv": "GMV",
    "legendOrders": "Đơn",
    "tooltipGmv": "GMV:",
    "tooltipOrders": "{{count}} đơn"
  },
  "topVariants": {
    "title": "Biến thể hàng đầu",
    "productLabel": "Chọn sản phẩm",
    "productPlaceholder": "Chọn một sản phẩm",
    "axisRevenue": "Doanh thu",
    "noVariants": "Không có biến thể cho sản phẩm này."
  },
  "pagination": {
    "summary": "Trang {{page}} / {{totalPages}} · tổng {{total}}",
    "prev": "Trước",
    "next": "Sau"
  },
  "state": {
    "refreshing": "Đang làm mới…"
  },
  "actions": {
    "retry": "Thử lại"
  },
  "comparison": {
    "placeholder": "Tính năng so sánh sản phẩm sẽ sớm ra mắt.",
    "periodA": "Kỳ A",
    "periodB": "Kỳ B",
    "periodAAria": "Chọn kỳ A",
    "periodBAria": "Chọn kỳ B",
    "kindAria": "Loại kỳ",
    "versus": "so với",
    "quarterLabel": "Q{{quarter}} {{year}}",
    "kind": {
      "month": "Tháng",
      "quarter": "Quý"
    },
    "matched": {
      "title": "Sản phẩm khớp",
      "subtitle": "Sản phẩm có mặt ở cả hai kỳ, kèm mức thay đổi từng chỉ số.",
      "columns": {
        "product": "Sản phẩm",
        "ordersA": "Đơn {{period}}",
        "ordersB": "Đơn {{period}}",
        "deltaOrders": "Δ Đơn",
        "itemsA": "Sản phẩm {{period}}",
        "itemsB": "Sản phẩm {{period}}",
        "deltaItems": "Δ Sản phẩm",
        "refundA": "Hoàn tiền {{period}}",
        "refundB": "Hoàn tiền {{period}}",
        "deltaRefund": "Δ Hoàn tiền"
      },
      "deltaUp": "tăng",
      "deltaDown": "giảm",
      "deltaFlat": "không đổi"
    },
    "changed": {
      "title": "Sản phẩm mới & ngừng bán",
      "subtitle": "Sản phẩm chỉ xuất hiện ở một kỳ.",
      "newIn": "Mới trong {{period}}",
      "droppedAfter": "Ngừng sau {{period}}",
      "columns": {
        "product": "Sản phẩm",
        "status": "Trạng thái",
        "orders": "Đơn",
        "items": "Số lượng",
        "refund": "Tỷ lệ hoàn tiền"
      }
    },
    "bySupplier": {
      "title": "Theo nhà cung cấp",
      "subtitle": "Sản phẩm mới và ngừng bán theo từng nhà cung cấp.",
      "none": "—",
      "columns": {
        "supplier": "Nhà cung cấp",
        "newCount": "Mới",
        "droppedCount": "Ngừng",
        "newProducts": "Sản phẩm mới",
        "droppedProducts": "Sản phẩm ngừng bán"
      }
    }
  },
  "forecast": {
    "placeholder": "Tính năng dự báo sẽ sớm ra mắt.",
    "title": "Dự báo {{targetYear}}",
    "subtitle": "Dải mùa vụ, dự phóng theo nhóm và khuyến nghị nửa cuối năm so với {{prevYear}}.",
    "degradeBanner": "Không đủ dữ liệu năm trước để dựng biểu đồ quạt mùa vụ. Chỉ hiển thị dự phóng dựa trên nhóm.",
    "fanChart": {
      "title": "Dự báo mùa vụ",
      "subtitle": "Dải giảm chấn ({{targetYear}}) so với thực tế",
      "actualLegend": "Thực tế",
      "band100": "Mùa vụ 100%",
      "band50": "Giảm chấn 50%",
      "band25": "Giảm chấn 25%",
      "empty": "Không có dữ liệu mùa vụ.",
      "xAxisLabel": "Tháng"
    },
    "cohort": {
      "title": "Dự phóng theo nhóm và kênh",
      "subtitle": "GMV nửa cuối năm dự phóng: {{value}}",
      "nonTiktok": "Ngoài TikTok",
      "tiktok": "TikTok",
      "total": "Tổng",
      "empty": "Không có dự phóng theo nhóm.",
      "drivers": {
        "title": "Yếu tố dẫn dắt dự phóng",
        "activeSellers": "Người bán hoạt động",
        "gmvPerSeller": "GMV trên mỗi người bán"
      }
    },
    "guidance": {
      "title": "Biến thể khuyến nghị",
      "recommended": "Khuyến nghị: {{variant}}",
      "none": "Không có biến thể nào được khuyến nghị duy nhất — hãy xem các đối chiếu bên dưới.",
      "reasonsTitle": "Đối chiếu",
      "variant": {
        "100pct": "Mùa vụ 100%",
        "50pct": "Giảm chấn 50%",
        "25pct": "Giảm chấn 25%"
      }
    },
    "halfYear": {
      "title": "Tóm tắt nửa năm",
      "subtitle": "Thực tế năm trước, thực tế nửa đầu năm nay, dự phóng nửa cuối và cả năm.",
      "empty": "Không có tóm tắt nửa năm.",
      "period": "Kỳ",
      "actualBadge": "Thực tế",
      "projectedBadge": "Dự phóng",
      "columns": {
        "nonTiktok": "Ngoài TikTok",
        "tiktok": "TikTok",
        "total": "Tổng"
      }
    },
    "assumptionsTitle": "Giả định"
  },
  "export": {
    "button": "Xuất",
    "dialogTitle": "Xuất báo cáo",
    "dialogDesc": "Chọn định dạng tệp. Quá trình tải xuống sẽ bắt đầu khi tệp sẵn sàng.",
    "formatLabel": "Định dạng tệp",
    "format": {
      "csv": "CSV",
      "xlsx": "Excel (XLSX)"
    },
    "cancel": "Huỷ",
    "confirm": "Xuất",
    "working": "Đang chuẩn bị…",
    "progress": "Đang chuẩn bị tệp… {{progress}}%",
    "started": "Đã bắt đầu xuất.",
    "ready": "Tệp đã sẵn sàng. Bắt đầu tải xuống.",
    "failed": "Xuất thất bại. Vui lòng thử lại.",
    "expired": "Bản xuất này đã hết hạn. Vui lòng xuất lại.",
    "failedTitle": "Xuất thất bại",
    "pollFailedTitle": "Không kiểm tra được trạng thái xuất"
  },
  "recompute": {
    "button": "Tính lại",
    "working": "Đang tính lại…",
    "confirmTitle": "Tính lại số liệu phân tích?",
    "confirmDesc": "Thao tác này sẽ dựng lại toàn bộ số liệu phân tích từ đầu và có thể mất vài phút. Dữ liệu hiện tại vẫn hiển thị cho đến khi có kết quả mới.",
    "confirm": "Tính lại",
    "cancel": "Huỷ",
    "started": "Đã bắt đầu tính lại.",
    "alreadyRunning": "Đã có một tiến trình tính lại đang chạy",
    "alreadyRunningDesc": "Một tiến trình tính lại đang chạy. Vui lòng đợi tiến trình này hoàn tất.",
    "failedTitle": "Tính lại thất bại"
  },
  "errors": {
    "generic": "Đã xảy ra lỗi.",
    "validation": "Một số bộ lọc không hợp lệ. Vui lòng kiểm tra lại.",
    "unauthenticated": "Phiên đăng nhập đã hết hạn. Vui lòng đăng nhập lại.",
    "forbidden": "Bạn không có quyền xem báo cáo này.",
    "invalidRange": "Khoảng thời gian đã chọn không hợp lệ.",
    "network": "Lỗi mạng. Vui lòng thử lại."
  }
}
